<template>
  <div>
    <nav id="layout_nav"
      class="navbar has-shadow is-fixed-top"
      role="navigation"
      aria-label="main navigation"
      v-if="!(inIframe && isSiteMsa)"
    >
      <div class="navbar-brand">
        <Link v-if="logo" href="/">
          <img :src="logo" alt="" id="logo-img" />
        </Link>
        <span class="navbar-item slogan" v-else-if="slogan">
          {{ slogan }}
        </span>
        <span class="navbar-item slogan" v-else> My simply agenda </span>

        <a
          role="button"
          class="navbar-burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarBasicExample"
          @click="toggleMenu"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarBasicExample" class="navbar-menu">
        <div class="navbar-start">
          <Link v-if="!this.redirected" class="navbar-item is-unselectable has-text-info" href="/">
            Accueil
          </Link>

          <Link
            class="navbar-item is-unselectable has-text-info"
            :href="this.redirected ? '/redirect/times'+this.redirect_params : '/ressources'"
            v-if="allowSignIn && !this.redirected || this.redirected"
          >
            Prendre rendez-vous
          </Link>
          <Link
            :href="'/account'+this.redirect_params"
            class="navbar-item is-unselectable has-text-info"
            v-if="user && allowSignIn">
            {{ this.redirected ? this.account_title : "Mon compte"}}
          </Link>
        </div>

        <div class="navbar-end">
          <div class="navbar-item" v-if="allowSignIn && !this.redirected">
            <div class="buttons">
              <a
                class="button is-info is-rounded shinny-effect"
                @click="toggleModal('#auth-modal')"
                id="auth-button"
                v-if="!user && withAuth"
              >
                Je m'authentifie
              </a>
              <a class="button is-light" v-if="user" @click="logout">
                Me déconnecter
              </a>
            </div>
          </div>
          <div class="navbar-item"  v-if="this.redirected">
            <div class="buttons">
              <a class="button is-danger" @click="cancel_redirect_rdv()">{{ this.fo_config['text']['RDV_BY_REDIRECT_btn_cancel'] }}</a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
  <div>
    <auth-modal v-on:userLogin="onUserLogin" v-bind:withAuth="withAuth" :autoBooking="autoBooking" v-on:submitWithoutAuth="(client) => $emit('submitWithoutAuth', client)"></auth-modal>
    <slot></slot>
  </div>
  <footer class="footer" v-if="!inIframe">
    <div class="content has-text-centered">
      <div class="columns">
        <div class="copyright column">
          <a href="https://mysimplyagenda.com" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 225.5 22.85">
              <g>
                <path
                  class="cls-1"
                  d="M35.94,11.29c-.18-.18-.44-.27-.77-.27h-3.34c-.34,0-.59,.09-.77,.27s-.27,.44-.27,.77v4.65c0,.23-.11,.35-.34,.35h-.84c-.22,0-.34-.12-.34-.35v-4.86c0-.7,.18-1.23,.55-1.61,.37-.38,.9-.56,1.61-.56h3.66c.91,0,1.54,.32,1.89,.96,.34-.64,.97-.96,1.89-.96h3.66c.7,0,1.24,.19,1.61,.56s.55,.91,.55,1.61v4.86c0,.23-.11,.35-.34,.35h-.83c-.23,0-.35-.12-.35-.35v-4.65c0-.34-.09-.6-.27-.77-.18-.18-.44-.27-.77-.27h-3.34c-.34,0-.59,.09-.77,.27-.18,.18-.27,.44-.27,.77v4.65c0,.23-.11,.35-.34,.35h-.83c-.23,0-.35-.12-.35-.35v-4.65c0-.34-.09-.6-.27-.77Z"
                />
                <path
                  class="cls-1"
                  d="M48.5,13.24c.18,.18,.44,.26,.77,.26h6.85c.34,0,.59-.09,.77-.26s.27-.44,.27-.78v-2.43c0-.23,.11-.35,.34-.35h.83c.23,0,.35,.12,.35,.35v2.64c0,.69-.18,1.23-.55,1.61-.37,.38-.9,.57-1.61,.57h-3.07v1.85c0,.23-.12,.35-.35,.35h-.83c-.22,0-.34-.12-.34-.35v-1.85h-3.07c-.7,0-1.24-.19-1.61-.57-.37-.38-.56-.92-.56-1.61v-2.64c0-.23,.12-.35,.35-.35h.83c.23,0,.35,.12,.35,.35v2.43c0,.34,.09,.6,.27,.78Z"
                />
                <path
                  class="cls-1"
                  d="M67.25,11.8v.14c0,.27,.08,.47,.23,.59,.15,.12,.39,.18,.71,.18h6.73c.35,0,.67,.03,.95,.09,.28,.06,.52,.17,.71,.32,.19,.15,.34,.34,.45,.57,.11,.24,.16,.52,.16,.87v.62c0,.34-.05,.64-.16,.87-.1,.24-.25,.43-.45,.58-.19,.15-.43,.25-.71,.32-.28,.06-.6,.09-.95,.09h-8.69c-.22,0-.34-.12-.34-.35v-.65c0-.22,.11-.34,.34-.34h8.49c.32,0,.56-.06,.71-.18,.15-.12,.23-.32,.23-.6v-.14c0-.27-.08-.47-.23-.59-.15-.12-.39-.18-.71-.18h-6.73c-.35,0-.67-.03-.94-.09s-.51-.17-.71-.32c-.19-.15-.34-.34-.45-.57-.1-.24-.16-.52-.16-.87v-.62c0-.34,.05-.64,.16-.87,.11-.24,.25-.43,.45-.58,.19-.15,.43-.25,.71-.32s.59-.09,.94-.09h8.58c.23,0,.35,.12,.35,.35v.65c0,.22-.12,.34-.35,.34h-8.38c-.62,0-.94,.26-.94,.78Z"
                />
                <path
                  class="cls-1"
                  d="M80.84,16.71c0,.23-.12,.35-.35,.35h-.83c-.23,0-.35-.12-.35-.35v-6.68c0-.23,.12-.35,.35-.35h.83c.23,0,.35,.12,.35,.35v6.68Z"
                />
                <path
                  class="cls-1"
                  d="M89.93,11.29c-.18-.18-.44-.27-.77-.27h-3.34c-.34,0-.59,.09-.77,.27s-.27,.44-.27,.77v4.65c0,.23-.11,.35-.34,.35h-.84c-.22,0-.34-.12-.34-.35v-4.86c0-.7,.18-1.23,.55-1.61,.37-.38,.9-.56,1.61-.56h3.66c.91,0,1.54,.32,1.89,.96,.34-.64,.97-.96,1.89-.96h3.66c.7,0,1.24,.19,1.61,.56s.55,.91,.55,1.61v4.86c0,.23-.11,.35-.34,.35h-.83c-.23,0-.35-.12-.35-.35v-4.65c0-.34-.09-.6-.27-.77-.18-.18-.44-.27-.77-.27h-3.34c-.34,0-.59,.09-.77,.27-.18,.18-.27,.44-.27,.77v4.65c0,.23-.11,.35-.34,.35h-.83c-.23,0-.35-.12-.35-.35v-4.65c0-.34-.09-.6-.27-.77Z"
                />
                <path
                  class="cls-1"
                  d="M101.06,10.03c0-.23,.12-.35,.35-.35h8.57c.72,0,1.27,.18,1.65,.54s.56,.89,.56,1.6v.61c0,.71-.19,1.24-.56,1.6-.38,.36-.93,.54-1.65,.54h-7.39v2.14c0,.23-.12,.35-.35,.35h-.83c-.23,0-.35-.12-.35-.35v-6.68Zm9.62,1.94c0-.32-.08-.55-.24-.71-.16-.16-.42-.24-.78-.24h-7.07v2.2h7.07c.36,0,.62-.08,.78-.23,.16-.15,.24-.39,.24-.71v-.32Z"
                />
                <path
                  class="cls-1"
                  d="M115.95,15.45c.18,.18,.44,.27,.77,.27h7.92c.23,0,.35,.11,.35,.34v.65c0,.23-.12,.35-.35,.35h-8.32c-.7,0-1.24-.19-1.61-.56-.37-.38-.55-.91-.55-1.61v-4.86c0-.23,.11-.35,.34-.35h.84c.22,0,.34,.12,.34,.35v4.65c0,.34,.09,.6,.27,.77Z"
                />
                <path
                  class="cls-1"
                  d="M127.86,13.24c.18,.18,.44,.26,.77,.26h6.85c.34,0,.59-.09,.77-.26s.27-.44,.27-.78v-2.43c0-.23,.11-.35,.34-.35h.83c.23,0,.35,.12,.35,.35v2.64c0,.69-.18,1.23-.55,1.61-.37,.38-.9,.57-1.61,.57h-3.07v1.85c0,.23-.12,.35-.35,.35h-.83c-.22,0-.34-.12-.34-.35v-1.85h-3.07c-.7,0-1.24-.19-1.61-.57-.37-.38-.56-.92-.56-1.61v-2.64c0-.23,.12-.35,.35-.35h.83c.23,0,.35,.12,.35,.35v2.43c0,.34,.09,.6,.27,.78Z"
                />
                <path
                  class="cls-1"
                  d="M145.35,11.85c0-.7,.18-1.23,.55-1.61,.37-.38,.9-.56,1.61-.56h7.17c.7,0,1.24,.19,1.61,.56s.56,.91,.56,1.61v4.86c0,.23-.12,.35-.35,.35h-.83c-.23,0-.35-.12-.35-.35v-1.92h-8.46v1.92c0,.23-.11,.35-.34,.35h-.84c-.22,0-.34-.12-.34-.35v-4.86Zm9.98,.21c0-.34-.09-.6-.26-.77-.18-.18-.44-.27-.78-.27h-6.37c-.34,0-.6,.09-.77,.27-.18,.18-.27,.44-.27,.77v1.39h8.46v-1.39Z"
                />
                <path
                  class="cls-1"
                  d="M170.76,15.19c0,.34-.05,.64-.16,.87s-.26,.43-.45,.58-.44,.25-.72,.32c-.28,.06-.59,.09-.94,.09h-7.18c-.7,0-1.24-.19-1.61-.56-.37-.38-.55-.91-.55-1.61v-3.03c0-.7,.18-1.23,.55-1.61,.37-.38,.9-.56,1.61-.56h8.68c.23,0,.35,.12,.35,.35v.65c0,.22-.12,.34-.35,.34h-8.28c-.34,0-.6,.09-.77,.27-.18,.18-.27,.44-.27,.77v2.61c0,.34,.09,.6,.27,.77,.18,.18,.44,.27,.77,.27h6.58c.32,0,.56-.06,.71-.18s.23-.32,.23-.6v-.92h-3.24c-.23,0-.35-.12-.35-.35v-.61c0-.23,.12-.35,.35-.35h4.42c.23,0,.35,.12,.35,.35v2.13Z"
                />
                <path
                  class="cls-1"
                  d="M174.38,14.68c0,.34,.09,.6,.27,.77,.18,.18,.44,.27,.77,.27h8.33c.23,0,.35,.11,.35,.34v.65c0,.23-.12,.35-.35,.35h-8.73c-.7,0-1.24-.19-1.61-.56-.37-.38-.55-.91-.55-1.61v-3.03c0-.7,.18-1.23,.55-1.61,.37-.38,.9-.56,1.61-.56h8.73c.23,0,.35,.12,.35,.35v.65c0,.22-.12,.34-.35,.34h-8.33c-.34,0-.6,.09-.77,.27-.18,.18-.27,.44-.27,.77v.65h8.32c.23,0,.35,.12,.35,.35v.61c0,.23-.12,.35-.35,.35h-8.32v.65Z"
                />
                <path
                  class="cls-1"
                  d="M186.77,10.25c.37-.38,.9-.56,1.61-.56h7.12c.7,0,1.24,.19,1.61,.56s.56,.91,.56,1.61v4.86c0,.23-.12,.35-.35,.35h-.83c-.23,0-.35-.12-.35-.35v-4.65c0-.34-.09-.6-.26-.77-.18-.18-.44-.27-.78-.27h-6.32c-.34,0-.6,.09-.77,.27-.18,.18-.27,.44-.27,.77v4.65c0,.23-.11,.35-.34,.35h-.84c-.22,0-.34-.12-.34-.35v-4.86c0-.7,.18-1.23,.55-1.61Z"
                />
                <path
                  class="cls-1"
                  d="M200.08,10.03c0-.23,.12-.35,.35-.35h8.66c.82,0,1.43,.22,1.86,.65,.42,.43,.64,1.05,.64,1.86v2.36c0,.81-.21,1.43-.64,1.86-.42,.43-1.04,.65-1.86,.65h-8.66c-.23,0-.35-.12-.35-.35v-6.68Zm9.99,2.35c0-.44-.12-.78-.35-1.01-.23-.23-.57-.35-1.02-.35h-7.09v4.7h7.09c.45,0,.79-.12,1.02-.35,.23-.23,.35-.57,.35-1.01v-1.98Z"
                />
                <path
                  class="cls-1"
                  d="M213.87,11.85c0-.7,.18-1.23,.55-1.61,.37-.38,.9-.56,1.61-.56h7.17c.7,0,1.24,.19,1.61,.56s.56,.91,.56,1.61v4.86c0,.23-.12,.35-.35,.35h-.83c-.23,0-.35-.12-.35-.35v-1.92h-8.46v1.92c0,.23-.11,.35-.34,.35h-.84c-.22,0-.34-.12-.34-.35v-4.86Zm9.98,.21c0-.34-.09-.6-.26-.77-.18-.18-.44-.27-.78-.27h-6.37c-.34,0-.6,.09-.77,.27-.18,.18-.27,.44-.27,.77v1.39h8.46v-1.39Z"
                />
              </g>
              <g>
                <path
                  class="cls-1"
                  d="M11.42,22.72C5.19,22.72,.12,17.66,.12,11.42S5.19,.12,11.42,.12h11.3V11.42c0,6.23-5.07,11.3-11.3,11.3Zm0-20.43C6.39,2.29,2.29,6.39,2.29,11.42s4.1,9.13,9.13,9.13,9.13-4.1,9.13-9.13V2.29H11.42Z"
                />
                <path
                  class="cls-1"
                  d="M11.42,16.68c-3.23,0-5.85-2.62-5.85-5.85s2.63-5.85,5.85-5.85,5.85,2.63,5.85,5.85-2.63,5.85-5.85,5.85Zm0-9.02c-1.75,0-3.17,1.42-3.17,3.17s1.42,3.17,3.17,3.17,3.17-1.42,3.17-3.17-1.42-3.17-3.17-3.17Z"
                />
              </g>
            </svg>
          </a>
        </div>
      </div>
      <div class="column">
        <div class="copyright">
          <p>Votre temps est précieux, optimisez le !</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.copyright svg {
  width: 300px;
  height: auto;
}

.copyright svg .cls-1 {
  fill: #271c49;
}

.buttons a {
    background-color: var(--btn-primary-bg-color);
    color: var(--btn-primary-text-color);
}

.buttons a:hover {
    background-color: var(--btn-primary-bg-color-hover);
    color: var(--btn-primary-text-color);
}
</style>

<script>
import { Inertia } from "@inertiajs/inertia";
import axios from 'axios'
import { Link } from "@inertiajs/inertia-vue3";
import AuthModal from "./AuthModal.vue";
import { toast } from "bulma-toast";

export default {
  name: "Layout",
  props: ["settingsConfig","config","fo_config", "account_title"],
  components: { AuthModal, Link },
  emits: ['submitWithoutAuth'],
  computed: {
    allowSignIn() {
      return !this.$page.props.config?.disabled_fo_signin;
    },
    inIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        console.log(e);
        return true;
      }
    },
    isSiteMsa() {
      return document.location.hostname === "teammsa.prordv.com";
    },
    logo() {
      return this.$page.props.logo;
    },
    slogan() {
      return this.$page.props.slogan;
    },
    user() {
      return this.$page.props.auth.user?.client?.[0];
    },
    withAuth(){
        return !(this.settingsConfig && this.settingsConfig["BOOK_WITHOUT_SUBSCRIPTION"] && this.settingsConfig["BOOK_WITHOUT_SUBSCRIPTION"] == 1);
    },
    autoBooking(){
        return (this.settingsConfig && this.settingsConfig["AUTO_BOOKING"] && this.settingsConfig["AUTO_BOOKING"] == 1);
    },
    redirected(){
      return this.fo_config && (this.fo_config['redirected'] == 1);
    },
    redirect_params(){
      if(!this.redirected){
        return '';
      }    

      let params = new URLSearchParams(window.location.search);
      params.delete('rdv_id');
      params.delete('redirected');
      return '?'+params+'&redirected=1';
    },    
  },
  methods: {
    logout() {
      this.$inertia.get("/auth/logout");
    },
    toggleModal(id) {
      let modal = document.querySelector(id);
      modal.classList.toggle("is-active");
    },
    toggleMenu() {
      let navbar_burger = document.querySelector(".navbar-burger");
      navbar_burger.classList.toggle("is-active");
      let menu = document.querySelector(".navbar-menu");
      menu.classList.toggle("is-active");
    },
    onUserLogin() {
      Inertia.reload({ only: ["auth.user"] });
      console.log('user',this.user);
    },
    get_redirected_params(){
      if(!this.redirected){
        return null;
      }

      let all_params = new URLSearchParams(window.location.search);
      let params = all_params.get('all_params_redirect');
      if(params != null){
        return JSON.parse(atob(params));
      }
      return null;
    },
    redirect(id_container, form) {
        console.log('in redirect');
        
        let container = document.getElementById(id_container);
        console.log('container',container,form);
        
        container.insertAdjacentHTML('afterbegin',form);
        let redirect_form = document.getElementById('rdv_redirect_form');
        redirect_form.submit();

        console.log('redirect element',redirect_form);
        
    },
    cancel_redirect_rdv(){
        if(this.redirected){
            let data = {};
            let params = this.get_redirected_params();
            console.log('cancel_redirect_rdv params',params);
            
            if(typeof params == 'object'){
              data.reservation_statut = 'ABANDON';
              data.ext_prestation_id = params.ext_prestation_id;
              
              if(typeof params.cancel_url == 'string' && params.cancel_url.length > 0) {data.cancel_url = params.cancel_url;}
              console.log('data to get form', data);
              
              axios
                    .post('/redirect/form/cancel',data)
                    .then((response) => {
                        this.redirect('layout_nav',response.data);
                    })
                    .catch((error) => {
                      toast({
                        message: this.$page.props.flash.message,
                        type: "is-danger",
                        duration: 5000,
                        pauseOnHover: true,
                      });
                    });
            }
            else{
              toast({
                    message: 'Paramètres de redirection manquantes',
                    type: "is-danger",
                    duration: 5000,
                    pauseOnHover: true,
                  });
                  this.$inertia.get(this.withAuth ? '/account'+this.redirect_params : '/');
            }
        }else{
            this.$inertia.get(this.withAuth ? '/account'+this.redirect_params : '/');
        }
    }
  },
  mounted() {
    if (this.$page.props.flash.message && !(this.config && this.config['confirm_web_rdv'] == 1) && !this.redirected) {
      toast({
        message: this.$page.props.flash.message,
        type: "is-success",
        duration: 5000,
        pauseOnHover: true,
      });
    }
  },
};
</script>
